import { Link } from "react-router-dom";
import PublicPageLayout from "../../components/publicSite/PublicPageLayout";

export default function ContactsPage() {
  return <PublicPageLayout title="Restiamo in contatto" eyebrow="Contatti" intro="Per informazioni sui laghi, sulle attività del parco e sulle gare, chiamaci o scrivici.">
    <div className="contact-layout">
      <dl className="contact-list">
        <div><dt>Email</dt><dd><a href="mailto:asdparcodellasciola@gmail.com">asdparcodellasciola@gmail.com</a></dd></div>
        <div><dt>Telefono</dt><dd><a href="tel:+393928687075">+39 392 868 7075</a><br /><a href="tel:+393926556115">+39 392 655 6115</a></dd></div>
        <div><dt>Indirizzo</dt><dd>Loc. Sassuolo, SNC<br />06023 Gualdo Tadino (PG)</dd></div>
      </dl>
      <aside className="contact-visit">
        <h2>Vieni a trovarci</h2>
        <p>Il Parco della Sciola e il lago dedicato al Trout Area si trovano a Gualdo Tadino. Nella pagina “Dove siamo” trovi le indicazioni per entrambe le strutture.</p>
        <Link className="site-button" to="/dove-siamo">Come raggiungerci →</Link>
      </aside>
    </div>
  </PublicPageLayout>;
}
